module.exports = __webpack_public_path__ + "static/media/Foto_(6).844a6156.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_archiv/Foto_(6).jpg
// module id = 575
// module chunks = 0